import { Box, styled } from '@mui/material';

export const CenterContentBox = styled(Box)`
  display: flex;
  justify-content: center;
  align-items: center;
`;
